import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import { Box, Flex, Typography } from "components/common/index"

const VibeSuccess = ({ promoCode }) => {
  return (
    <Box px={5} py={2}>
      <Typography as="h2" fontSize={14} mb={2}>
        Thank you for entering the Jewlr contest. While you’re here - start
        shopping and celebrate the special moments with personalized jewelry
        that is truly unique!
      </Typography>

      <Typography fontSize={14} mb={2}>
        Enter this coupon code to receive <strong>20% OFF*</strong> your next
        order!
      </Typography>

      <Flex justifyContent="center" mb={2}>
        <Typography fontSize={14} mr={2}>
          Promo Code:
        </Typography>
        <Typography fontSize={14}>{promoCode}</Typography>
      </Flex>

      <Flex justifyContent="space-evenly">
        <Typography>
          <small>*Some restrictions apply</small>
        </Typography>
        <Link data-lc="vibe-success" to="/">
          <Box
            alt="Jewlr"
            as="img"
            ratio="701 / 139"
            src={require("images/layout/logo/jewlr-logo.svg")}
            width="120px"
          />
        </Link>
      </Flex>
    </Box>
  )
}

VibeSuccess.propTypes = {
  promoCode: PropTypes.string,
}

export default VibeSuccess
